import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {SearchType} from './constants';
import {AdvancedRawRuleEditorGeneric} from './advancedRaw/components';
import {AttributeHistoryRuleEditor} from './attributeHistory/components';
import {CartRuleEditor} from './cart/components';
import {CategoryIdRuleEditorGeneric} from './categoryId/components';
import {CheckoutsRuleEditorGeneric} from './checkouts/components';
import {ContentsRuleEditorGeneric} from './contents/components';
import {CustomRuleEditorGeneric} from './custom/components';
import {DateRuleEditorGeneric} from './date/components';
import {ExpirationRuleEditor} from './expiration/components';
import {FileAspectRuleEditorGeneric} from './fileAspect/components';
import {FileFormatRuleEditorGeneric} from './fileFormat/components';
import {FileFormatFamilyRuleEditorGeneric} from './fileFormatFamily/components';
import {FileSizeRuleEditorGeneric} from './fileSize/components';
import {KeywordRuleEditorGeneric} from './keyword/components';
import {MetadataRuleEditorGeneric} from './metadata/components';
import {SavedSearchRuleEditor} from './savedSearch/components';
import {UserRuleEditorGeneric} from './user/components';
import {VisualRuleEditorGeneric} from './visual/components';

// DAM-23532 - removing these from the portal (for now)
const portal = isBrandPortal();

export const RuleEditorComponentMap = <const>{
	[SearchType.ADVANCED_RAW]: portal ? undefined : AdvancedRawRuleEditorGeneric,
	[SearchType.ATTRIBUTE_HISTORY]: portal
		? undefined
		: AttributeHistoryRuleEditor,
	[SearchType.CART]: CartRuleEditor,
	[SearchType.CATEGORY_ID]: portal ? undefined : CategoryIdRuleEditorGeneric,
	[SearchType.CHECKOUTS]: portal ? undefined : CheckoutsRuleEditorGeneric,
	[SearchType.CONTENTS]: ContentsRuleEditorGeneric,
	[SearchType.CUSTOM]: CustomRuleEditorGeneric,
	[SearchType.DATE]: DateRuleEditorGeneric,
	[SearchType.EXPIRE]: ExpirationRuleEditor,
	[SearchType.FILE_ASPECT]: FileAspectRuleEditorGeneric,
	[SearchType.FILE_FORMAT]: FileFormatRuleEditorGeneric,
	[SearchType.FILE_FORMAT_FAMILY]: FileFormatFamilyRuleEditorGeneric,
	[SearchType.FILE_SIZE]: FileSizeRuleEditorGeneric,
	[SearchType.KEYWORD]: KeywordRuleEditorGeneric,
	[SearchType.METADATA]: MetadataRuleEditorGeneric,
	[SearchType.SAVED_SEARCH]: SavedSearchRuleEditor,
	[SearchType.USER]: portal ? undefined : UserRuleEditorGeneric,
	[SearchType.VISUAL]: VisualRuleEditorGeneric,
};

/**
 * Given search rule type, get an editor component
 * @param searchType search type
 * @returns
 */
export const getEditorComponent = (searchType: SearchType) =>
	RuleEditorComponentMap[searchType];

export default getEditorComponent;
